module.exports = "/static/media/sso.680b07e6.png";